import {
    modulus
} from '../helpers';

export const bankAccountValidator = {

    validate(accountNumber, log) {
        var bankName = this.getBankName(accountNumber, log);
        if(log) console.log("Bankname: " + bankName);

        return bankName != null;
    },

    getBankName(accountNumber, log) {
        if(!accountNumber) return null;
        
        accountNumber = accountNumber.split(" ").join("").split("-").join("")

        if(this.isType2A("(918[0-9])", accountNumber, log)) return "Danske Bank";
        if(this.isType2B("(6[0-8][0-9]{2}|69[0-8][0-9]|699[0-9])", accountNumber, log)) return "Handelsbanken";
        if(this.isType2C("(95[0-3][0-9]|954[0-9])", accountNumber, log)) return "Nordea";
        if(this.isType2C("(996[0-9])", accountNumber, log)) return "Nordea";
        if(this.isType2A("(3300)", accountNumber, log)) return "Nordea";
        if(this.isType2A("(3782)", accountNumber, log)) return "Nordea";
        if(this.isType2A("(989[0-9])", accountNumber, log)) return "Riksgälden";
        if(this.isType2A("(957[0-9])", accountNumber, log)) return "Sparbanken Syd";
        if(this.isType2C("(8[0-8][0-9]{2}|89[0-8][0-9]|899[0-9])", accountNumber, log)) return "Swedbank";
        if(this.isType2A("(93[01][0-9]|932[0-9])", accountNumber, log)) return "Swedbank";
        if(this.isType2A("(933[0-9]|934[0-9])", accountNumber, log)) return "Swedbank";
        if(this.isType1A("(5[0-8][0-9]{2}|59[0-8][0-9]|599[0-9])", accountNumber, log)) return "SEB";

        if(this.isType1B("(966[0-9])", accountNumber, log)) return "Amfa Bank";
        if(this.isType1B("(955[0-9]|956[0-9])", accountNumber, log)) return "Avanza Bank";
        if(this.isType1A("(968[0-9])", accountNumber, log)) return "Bluestep";
        if(this.isType1B("(947[0-9])", accountNumber, log)) return "BNP Paribas";
        if(this.isType1B("(904[0-9])", accountNumber, log)) return "Citibank";
        if(this.isType1A("(12[0-9]{2}|13[0-8][0-9]|139[0-9])", accountNumber, log)) return "Danske Bank";
        if(this.isType1A("(24[0-8][0-9]|249[0-9])", accountNumber, log)) return "Danske Bank";
        if(this.isType1B("(919[0-9])", accountNumber, log)) return "DNB";        
        if(this.isType1B("(926[0-9])", accountNumber, log)) return "DNB";                
        if(this.isType1B("(970[0-9])", accountNumber, log)) return "Ekobanken";  
        if(this.isType1B("(959[0-9])", accountNumber, log)) return "Erik Penser";  
        if(this.isType1A("(94[0-3][0-9]|944[0-9])", accountNumber, log)) return "Forex"; 
        if(this.isType1A("(927[0-9])", accountNumber, log)) return "ICA Banken";
        if(this.isType1A("(917[0-9])", accountNumber, log)) return "IKANO";  
        if(this.isType1B("(967[0-9])", accountNumber, log)) return "JAK Medlemsbank";
        if(this.isType1B("(939[0-9])", accountNumber, log)) return "Landshypotek";
        if(this.isType1A("(963[0-9])", accountNumber, log)) return "Lån & Spar";
        if(this.isType1A("(340[0-9])", accountNumber, log)) return "Länsförsäkringar";
        if(this.isType1B("(902[0-9])", accountNumber, log)) return "Länsförsäkringar";                                
        if(this.isType1A("(906[0-9])", accountNumber, log)) return "Länsförsäkringar";
        if(this.isType1B("(965[0-9])", accountNumber, log)) return "MedMera";
        if(this.isType1B("(964[0-9])", accountNumber, log)) return "Nordax";
        if(this.isType1A("(965[0-9])", accountNumber, log)) return "MedMera";
        if(this.isType1A("(11[0-8][0-9]|119[0-9])", accountNumber, log)) return "Nordea";
        if(this.isType1A("(1[4-8][0-9]{2}|19[0-8][0-9]|199[0-9]|20[0-8][0-9]|209[0-9])", accountNumber, log)) return "Nordea";
        if(this.isType1A("(3[01][0-9]{2}|32[0-8][0-9]|329[0-9])", accountNumber, log)) return "Nordea";
        if(this.isType1A("(330[1-9]|33[1-9][0-9])", accountNumber, log)) return "Nordea";
        if(this.isType1A("(34[1-8][0-9]|349[0-9]|3[56][0-9]{2}|37[0-7][0-9]|378[01])", accountNumber, log)) return "Nordea";
        if(this.isType1A("(378[3-9]|379[0-9]|3[89][0-9]{2})", accountNumber, log)) return "Nordea";
        if(this.isType1B("(4[0-8][0-9]{2}|49[0-8][0-9]|499[0-9])", accountNumber, log)) return "Nordea";
        if(this.isType1B("(4190)", accountNumber, log)) return "Nordea";
        if(this.isType1B("(910[0-9])", accountNumber, log)) return "Nordnet";
        if(this.isType1A("(928[0-9])", accountNumber, log)) return "Resurs";
        if(this.isType1B("(998[0-9])", accountNumber, log)) return "Riksgälden";
        if(this.isType1A("(925[0-9])", accountNumber, log)) return "SBAB";
        if(this.isType1A("(5[0-8][0-9]{2}|59[0-8][0-9]|599[0-9])", accountNumber, log)) return "SEB";
        if(this.isType1A("(912[0-4])", accountNumber, log)) return "SEB";
        if(this.isType1A("(913[0-9]|914[0-9])", accountNumber, log)) return "SEB";
        if(this.isType1B("(915[0-9]|916[0-9])", accountNumber, log)) return "Skandiabanken";
        if(this.isType1A("(7[0-8][0-9]{2}|79[0-8][0-9]|799[0-9])", accountNumber, log)) return "Swedbank";
        if(this.isType1A("(23[0-8][0-9]|239[0-9])", accountNumber, log)) return "Ålandsbanken";
        
        if(log) console.log(accountNumber + " not passed");
        return null;
    },

    isType1A(clearingNumberRegex, accountNumber, log) {
        if(accountNumber.length < 11) return false;

        accountNumber = accountNumber.substring(0, 4) + this.pad(accountNumber.substr(4), 12, 0);
        var regexp = new RegExp("^" + clearingNumberRegex + "\\d{0,5}\\d{7}$");
        if(!regexp.test(accountNumber)) return false;
        if(log) console.log(accountNumber + " passed regexp for type 1 A");

        return modulus.modulus11Validation(accountNumber.substring(1, 4) +
            accountNumber.substr(accountNumber.length - 7), log);
    },

    isType1B(clearingNumberRegex, accountNumber, log) {
        if(accountNumber.length < 11) return false;

        accountNumber = accountNumber.substring(0, 4) + this.pad(accountNumber.substr(4), 12, 0);
        var regexp = new RegExp("^" + clearingNumberRegex + "\\d{0,5}\\d{7}$");
        if(!regexp.test(accountNumber)) return false;
        if(log) console.log(accountNumber + " passed regexp for type 1 B ");  

        return modulus.modulus11Validation(accountNumber.substring(0, 4) +
            accountNumber.substr(accountNumber.length - 7), log);
    },

    isType2A(clearingNumberRegex, accountNumber, log) {
        if(accountNumber.length < 14) return false;        

        accountNumber = accountNumber.substring(0, 4) + this.pad(accountNumber.substr(4), 12, 0);
        var regexp = new RegExp("^" + clearingNumberRegex + "\\d{0,5}\\d{7}$");
        if(!regexp.test(accountNumber)) return false;
        if(log) console.log(accountNumber + " passed regexp for type 2 A");
 
        return modulus.modulus10Validation(accountNumber.substring(accountNumber.length - 10), log);
    },

    isType2B(clearingNumberRegex, accountNumber, log) {
        if(accountNumber.length < 13) return false;        

        accountNumber = accountNumber.substring(0, 4) + this.pad(accountNumber.substr(4), 12, 0);
        var regexp = new RegExp("^" + clearingNumberRegex + "\\d{0,5}\\d{7}$");
        if(!regexp.test(accountNumber)) return false;
        if(log) console.log(accountNumber + " passed regexp for type 2 B");
 
        return modulus.modulus11Validation(accountNumber.substring(accountNumber.length - 9), log);
    },

    isType2C(clearingNumberRegex, accountNumber, log) {
        if(accountNumber.length < 14) return false;        

        accountNumber = accountNumber.substring(0, 4) + this.pad(accountNumber.substr(4), 12, 0);
        var regexp = new RegExp("^" + clearingNumberRegex + "\\d{0,5}\\d{7}$");
        if(!regexp.test(accountNumber)) return false;
        if(log) console.log(accountNumber + " passed regexp for type 2 C");
 
        return modulus.modulus10Validation(accountNumber.substring(accountNumber.length - 10), log);
    },

    pad(n, width, z) {
        z = z || '0';
        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    }

}

